import { ConfigProvider } from "antd";
import { FC, PropsWithChildren } from "react";

export const Theme: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemColor: "#384853",
            itemHoverColor: "#11643C",
            itemSelectedColor: "#11643C",
            inkBarColor: "#11643C",
            itemActiveColor: "#11643C",
            lineWidthFocus: 6,
            titleFontSizeLG: 16,
            fontFamily: 'BRFirma-Medium', 
          },
          Divider: {
            colorSplit: '#8DC467',
            margin: 0,
            marginLG: 3,
            lineWidth: 2,
          },
          Form: {
            itemMarginBottom: 10,
            fontFamily: 'BRFirma-Medium',
          },
          Checkbox: {
            colorBorder: '#11643C',
            colorPrimary: '#11643C',
            colorPrimaryHover: '#11643C',
            colorBgContainer: '#ffffff',
            colorText: '#5F6063',
          },
          Table: {
            borderColor: '#E5E6E6',
            headerBg: '#DCF9EB',
            headerBorderRadius: 0,
            cellPaddingInline: 20,
            cellPaddingBlock: 10,
            footerBg: '#11643C',
            footerColor: "#011602",
            rowSelectedHoverBg:"#DCF9EB",
            fontFamily: 'BRFirma-Medium',
          },
          Modal: {
            padding: 32,
            borderRadiusLG: 18
          },
          Radio:{
            buttonSolidCheckedActiveBg: "#11643C",
            buttonSolidCheckedBg: "#11643C",
            colorPrimary: "#11643C",
            fontFamily: 'BRFirma-Medium',
          },
          Card: {
            borderRadiusLG: 20,
            fontFamily: 'BRFirma-Medium',
          },
          Steps:{
            colorPrimary:"#68B859",
            colorPrimaryBorder: "#68B859",
          },
          Spin: {
            colorPrimary: '#8dc467',
          },
          Popover: {
            borderRadiusLG: 20,
            sizePopupArrow: 0,
          },
          Pagination: {
            itemActiveBg: "#11643C",
            colorBorder: "#11643C",
            itemBg: "#fff",
            // colorPrimary: "#11643C",
            colorText: "#11643C",
            colorBgTextActive: "#fff",
            colorBgTextHover: "#fff",
            colorPrimaryBorder: "#11643C",
          }
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};


